import type { Datapoint, TechnologyCost } from '@netpurpose/types'
import { valueIsDefined } from '@netpurpose/utils'
import { pickBy } from 'lodash'
import { DatapointTypes } from '../../generated/modelling'
import type { ReverseFieldMap } from '../../queryBuilder'
import { formatPartialDatapoint } from './formatPartialDatapoint'
import type { BackendTechnologyCost } from './types'

export const formatPartialTechnologyCost = (
  technologyCost: Partial<TechnologyCost>,
): Partial<BackendTechnologyCost> => {
  return {
    ...formatPartialDatapoint(technologyCost as Datapoint),
    type: DatapointTypes.TECHNOLOGY_COST,
    ...pickBy(
      {
        unit_id: technologyCost.numeratorUnitId,
        numerator_unit_id: technologyCost.numeratorUnitId,
        reported_unit_id: technologyCost.numeratorReportedUnitId,
        numerator_reported_unit_id: technologyCost.numeratorReportedUnitId,
        denominator_unit_id: technologyCost.denominatorUnitId,
        denominator_reported_unit_id: technologyCost.denominatorReportedUnitId,
        is_primary_cost: technologyCost.isPrimaryCost,
        impact_question_id: technologyCost.impactQuestionId,
      },
      valueIsDefined,
    ),
    ...(technologyCost?.technology
      ? {
          technology: {
            technology_id: technologyCost.technology.id,
            name: technologyCost.technology.name,
            parent_id: technologyCost.technology.parentId,
          },
        }
      : {}),
  }
}

export const technologyCostReverseFieldMap: ReverseFieldMap<string> = {
  id: 'datapoint_id',
  status: 'status',
  'technology.name': 'technology.name',
  'technology.domainName': 'technology.domain_name',
  'technology.baseline': 'technology.baseline',
}
